import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/Redux/RootReducer';

const generateDocumentNumberModal = (state: RootState) => state.modalWindows.generateDocumentNumbersModalState;

const numberGenerateRequest = createSelector(generateDocumentNumberModal, (state) => state.numberGenerateRequest);

const numberGenerateType = createSelector(generateDocumentNumberModal, (state) => state.numberGenerateRequest?.genType);

export const generateDocumentNumberModalSelectors = {
  numberGenerateRequest,
  numberGenerateType,
};
